"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyStreetViewsResponse$ = exports.PropertyStreetViewsResponse$outboundSchema = exports.PropertyStreetViewsResponse$inboundSchema = void 0;
exports.propertyStreetViewsResponseToJSON = propertyStreetViewsResponseToJSON;
exports.propertyStreetViewsResponseFromJSON = propertyStreetViewsResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertystreetviewswrapper_js_1 = require("./propertystreetviewswrapper.js");
/** @internal */
exports.PropertyStreetViewsResponse$inboundSchema = z.object({
    data: z.array(propertystreetviewswrapper_js_1.PropertyStreetViewsWrapper$inboundSchema),
});
/** @internal */
exports.PropertyStreetViewsResponse$outboundSchema = z.object({
    data: z.array(propertystreetviewswrapper_js_1.PropertyStreetViewsWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyStreetViewsResponse$;
(function (PropertyStreetViewsResponse$) {
    /** @deprecated use `PropertyStreetViewsResponse$inboundSchema` instead. */
    PropertyStreetViewsResponse$.inboundSchema = exports.PropertyStreetViewsResponse$inboundSchema;
    /** @deprecated use `PropertyStreetViewsResponse$outboundSchema` instead. */
    PropertyStreetViewsResponse$.outboundSchema = exports.PropertyStreetViewsResponse$outboundSchema;
})(PropertyStreetViewsResponse$ || (exports.PropertyStreetViewsResponse$ = PropertyStreetViewsResponse$ = {}));
function propertyStreetViewsResponseToJSON(propertyStreetViewsResponse) {
    return JSON.stringify(exports.PropertyStreetViewsResponse$outboundSchema.parse(propertyStreetViewsResponse));
}
function propertyStreetViewsResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyStreetViewsResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyStreetViewsResponse' from JSON`);
}
//# sourceMappingURL=propertystreetviewsresponse.js.map